import { Disclosure } from "@headlessui/react";
import clsx from "clsx";
import { useRouter } from "next/router";

export default function MobileNavLink({
  name,
  path,
}: {
  name: string;
  path: string;
}) {
  const { pathname } = useRouter();
  return (
    <Disclosure.Button
      key={name}
      as="a"
      href={path}
      className={clsx(
        path === pathname
          ? "bg-succinct-teal-20 text-white"
          : "text-white hover:bg-succinct-teal-20 hover:bg-opacity-75",
        "block rounded-md py-2 px-3 text-base font-medium"
      )}
      aria-current={path === pathname ? "page" : undefined}
    >
      {name}
    </Disclosure.Button>
  );
}
